import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiLinkedin } = FiIcons;

const SocialProfiles = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      icon: FiFacebook,
      url: 'https://www.facebook.com/namvoro',
      color: 'hover:text-blue-600'
    },
    {
      name: 'Twitter',
      icon: FiTwitter,
      url: 'https://twitter.com/namvoro',
      color: 'hover:text-blue-400'
    },
    {
      name: 'Instagram',
      icon: FiInstagram,
      url: 'https://www.instagram.com/namvoro',
      color: 'hover:text-pink-500'
    },
    {
      name: 'YouTube',
      icon: FiYoutube,
      url: 'https://www.youtube.com/c/namvoro',
      color: 'hover:text-red-600'
    },
    {
      name: 'LinkedIn',
      icon: FiLinkedin,
      url: 'https://www.linkedin.com/company/namvoro',
      color: 'hover:text-blue-700'
    }
  ];

  return (
    <section className="py-12 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-2xl font-bold text-slate-900 mb-8">
            Connect With Us
          </h2>
          <div className="flex justify-center space-x-6">
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${social.color}`}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                aria-label={`Follow us on ${social.name}`}
              >
                <SafeIcon icon={social.icon} className="w-5 h-5 text-slate-600" />
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProfiles;